import decimalPlacesOf from './decimalPlacesOf';

export default (value, digits) => decimalPlacesOf(value) > digits;
